import { defineMessages } from '@transcend-io/internationalization';

export const pendingRequestsMessages = defineMessages(
  'privacy-center.containers.PendingRequests.pendingRequests',
  {
    showLess: {
      defaultMessage: 'Show active requests only',
    },
    noRequests: {
      defaultMessage:
        'No past requests found with identifier "{user}". Try clicking "{takeControl}" to make a new request.',
    },
    showMore: {
      defaultMessage: 'Show all past requests',
    },
    more: {
      defaultMessage: 'View more',
    },
    mobileLabel: {
      defaultMessage:
        'View your {activeNotificationCount} {activeNotificationCount, plural, one {request} other {requests}}',
    },
  },
);
